<main class="onboarding-shell-main min-h-dvh bg-[#F3F4F6] text-[#24324A]">
  <router-outlet />
</main>
